import { useRef, useState } from "react";
import { Button } from "@remo-co/ui-core/src/components/Button";
import { Container } from "@remo-co/ui-core/src/components/Container";
import { useI18n } from "i18n";
import { useCompanyPlanSettings } from "modules/companyPlanSettings";
import useCompanyEventDirectory from "../../hooks/useCompanyEventDirectory";
import EventDirectoryDialog from "../EventDirectoryDialog";
import { UpsellPopover } from "../../components";
import { useStyles } from "./styles";

const CreateDirectoryButton = () => {
  const { t } = useI18n(["eventDirectory"]);
  const styles = useStyles();
  const buttonRef = useRef<null | HTMLButtonElement>(null);
  const [isDialogOpen, setDialogOpen] = useState(false);
  const [isUpsellPopupOpen, setUpsellPopupOpen] = useState(false);
  const { companyEventDirectories } = useCompanyEventDirectory();
  const { getDirectoryLimit } = useCompanyPlanSettings();
  const companyDirectoryLimit = getDirectoryLimit();
  const toggleDialog = () => {
    if (companyEventDirectories.length >= companyDirectoryLimit) {
      setUpsellPopupOpen(true);
    } else {
      setDialogOpen(true);
    }
  };
  const closeDialog = () => {
    setDialogOpen(false);
  };
  const closePopover = () => {
    setUpsellPopupOpen(false);
  };

  // do not show button if there are no EDs since we have a blank state
  if (!companyEventDirectories.length) {
    return null;
  }

  return (
    <Container top="sm" fullWidth={false} className={styles.button}>
      <Button
        ref={buttonRef}
        data-testid="create-directory-button"
        variant="secondary"
        size="md"
        aria-label={t("eventDirectory:create.event.directory")}
        onClick={toggleDialog}
      >
        {t("eventDirectory:create.event.directory")}
      </Button>
      {isDialogOpen && <EventDirectoryDialog handleClose={closeDialog} />}
      <UpsellPopover
        containerRef={buttonRef}
        isVisible={isUpsellPopupOpen}
        closePopover={closePopover}
      />
    </Container>
  );
};

export default CreateDirectoryButton;
